// extracted by mini-css-extract-plugin
export var externalLink = "_cn-0";
export var internalLinkLabel = "_cn-1";